import React from 'react';
import { TableCell, TableRow, Typography } from '@medely/web-components';
import { Link } from 'react-admin';
import { IAssignmentChanges, IAssignment } from './Migrate';

const HappyPathAssignments = ({ count, from, to }: { count: number; from: number; to: number }) => {
  return (
    <TableRow>
      <TableCell>
        <Typography>Assignments</Typography>
      </TableCell>
      <TableCell>
        <Typography>
          {`- Migrated ${count} Assignments from `}
          <Link
            target="_blank"
            rel="noopener noreferrer"
            to={`/Company/${from}/show`}
          >{`Company ${from}`}</Link>
          {' to '}
          <Link
            target="_blank"
            rel="noopener noreferrer"
            to={`/Company/${to}/show`}
          >{`Company ${to}`}</Link>
        </Typography>
      </TableCell>
    </TableRow>
  );
};

export const AssignmentsMigrate = ({
  assignments,
  originalCompanyId,
}: {
  assignments: IAssignmentChanges | IAssignment[];
  originalCompanyId: number | undefined;
}) => {
  // When the audits are grouped as IAssignmentChanges, we can simply display the aggregated info
  if ('count' in assignments) {
    return (
      <HappyPathAssignments
        count={assignments.count || 0}
        from={assignments.updated.company_id[0]}
        to={assignments.updated.company_id[1]}
      />
    );
  }

  // When the audits are not grouped, they are returned as an array of individual IAssignment objects
  const groupedAssignments = assignments.reduce<Record<number, IAssignment[]>>(
    (acc, assignment) => {
      const firstCompanyId = assignment.updated?.company_id?.[0];
      if (firstCompanyId) {
        if (!acc[firstCompanyId]) {
          acc[firstCompanyId] = [];
        }
        acc[firstCompanyId].push(assignment);
      }
      return acc;
    },
    {},
  );

  return (
    <>
      {Object.entries(groupedAssignments).map(([companyId, assignmentList]) =>
        Number(companyId) === originalCompanyId ? (
          <HappyPathAssignments
            count={assignmentList.length}
            from={Number(companyId)}
            to={assignmentList[0]?.updated?.company_id?.[1] || 0}
          />
        ) : (
          <TableRow>
            <TableCell>
              <Typography>Assignments</Typography>
            </TableCell>
            <TableCell>
              <Typography>
                {`- Found ${assignmentList.length} Assignments with mismatched Company ID `}
                <Link target="_blank" rel="noopener noreferrer" to={`/Company/${companyId}/show`}>
                  {companyId}
                </Link>
                {assignmentList.length <= 5 && (
                  <>
                    {' (IDs: '}
                    {assignmentList.map((assignment, index) => (
                      <span key={assignment.id}>
                        {assignment.id}
                        {index < assignmentList.length - 1 ? ', ' : ''}
                      </span>
                    ))}
                    {')'}
                  </>
                )}
              </Typography>
            </TableCell>
          </TableRow>
        ),
      )}
    </>
  );
};
